const supportChatButtonSelector = '.mh-analytic[data-open-support-chat]';
const supportAssistantFrameSelector = 'iframe[title="Chat content"]';
const openTimeoutMs = 30_000;

let pendingOpen = false;
let pendingOpenTimeout: number | undefined;

export function registerSupportAssistantAnalytics(): void {
  document.addEventListener(
    'click',
    (event: Event) => {
      const target = event.target;
      if (!(target instanceof Element) || !target.closest(supportChatButtonSelector)) return;

      pendingOpen = true;
      if (pendingOpenTimeout !== undefined) window.clearTimeout(pendingOpenTimeout);
      pendingOpenTimeout = window.setTimeout(() => {
        pendingOpen = false;
        pendingOpenTimeout = undefined;
      }, openTimeoutMs);
    },
    true
  );

  document.addEventListener(
    'load',
    (event: Event) => {
      const iframe = event.target;
      if (
        !pendingOpen ||
        !(iframe instanceof HTMLIFrameElement) ||
        !iframe.matches(supportAssistantFrameSelector)
      ) {
        return;
      }

      pendingOpen = false;
      if (pendingOpenTimeout !== undefined) window.clearTimeout(pendingOpenTimeout);
      pendingOpenTimeout = undefined;

      (window as any).Mhecomm?.emit(
        'support_assistant_opened',
        {
          assistant_name: 'Athena Virtual Support Assistant',
          action: 'open',
          result: 'success',
          entry_point: 'chat_now_button',
        },
        {},
        iframe
      );
    },
    true
  );
}